import React, { useState, useEffect, useCallback } from 'react';

import { InputAdornment } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { generateCSVDataApi } from 'api/admin';
import { useSelector } from 'react-redux';
import DownloadCSVData from 'screens/analytics/commonComponents/DownloadCSVData';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { CenterItemFlexContainer, NewStyledIconButton, VerticallyCenterContainer } from 'styles/common';

import { isNumeric } from 'constants/helper';
import { StyledIcon } from 'constants/icons';
import { localStorageKeys } from 'constants/localStorageKeys';
import theme from 'constants/theme';

import { getEmployeeCount } from 'services/admin';

import { Typography13 } from 'uiToolkit/Typography';

import { StyledTextField, StyledHeaderBar } from './styles';

export const HeaderBar = ({ reloadCount, onSearchSubmit, addEmployee, openBulkUploadSidePanel, ...props }) => {
  const [searchText, setSearchText] = useState('');

  const submitHandler = (event) => {
    // prevent default for form submit.
    event.preventDefault();

    // blur textfield element
    const formElem = event.target;
    const searchBox = formElem.elements.search;

    searchBox.blur();

    // submit search request.
    onSearchSubmit(searchText);
    console.log('search submitted');
  };

  useEffect(() => {
    setSearchText(props.searchText);
  }, [props.searchText]);

  return (
    <StyledHeaderBar elevation={0}>
      <form onSubmit={submitHandler}>
        <StyledTextField
          name="search"
          margin="dense"
          variant="outlined"
          value={searchText}
          placeholder="Search"
          onChange={({ target }) => {
            setSearchText(target.value);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <NewStyledIconButton disabled={props.searchText.length === 0} onClick={() => onSearchSubmit('')}>
                  <StyledIcon
                    opacity={0.75}
                    size="smallest"
                    color={props.searchText.length === 0 ? 'textSecondary' : 'red'}
                  >
                    {props.searchText.length > 0 ? null : <SearchIcon />}
                  </StyledIcon>
                </NewStyledIconButton>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="start">
                <NewStyledIconButton disabled={props.searchText.length === 0} onClick={() => onSearchSubmit('')}>
                  <StyledIcon
                    opacity={0.75}
                    size="smallest"
                    color={props.searchText.length === 0 ? 'textSecondary' : 'red'}
                  >
                    {props.searchText.length > 0 ? <CloseIcon /> : null}
                  </StyledIcon>
                </NewStyledIconButton>
              </InputAdornment>
            ),
          }}
        />
      </form>
      <EmployeeCountAndCSVDownload reloadCount={reloadCount} />
    </StyledHeaderBar>
  );
};

const EmployeeCountAndCSVDownload = ({ reloadCount }) => {
  const [employeeCount, setEmployeeCount] = useState(0);
  const { organization } = useSelector(selectLoggedInEmployeeData);
  const { id: orgId } = organization;

  const generateCSVData = useCallback(() => generateCSVDataApi(), []);

  useEffect(() => {
    // console.log('loggedInEmployee22', loggedInEmployee);
    getEmployeeCount({ orgId })
      .then((employeeCount) => {
        if (isNumeric(employeeCount)) {
          setEmployeeCount(employeeCount);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reloadCount, orgId]);

  return (
    <VerticallyCenterContainer>
      <Typography13 color={theme.palette.text.label} rightGutter={2}>
        Total Employees
      </Typography13>
      <StyledCountContainer>
        <Typography13 color="primary">{employeeCount}</Typography13>
      </StyledCountContainer>
      <VerticalDivider />
      <DownloadCSVData
        localStorageKey={localStorageKeys.adminEmployeesCSVDownloads}
        downloadText="Download Employee Data"
        generateCSVData={generateCSVData}
        showSuccessToast
        toastMessage="A copy of this report has been emailed to you as well"
      />
    </VerticallyCenterContainer>
  );
};

const StyledCountContainer = styled(CenterItemFlexContainer)`
  background-color: ${(props) => props.theme.palette.background.lightBlue};
  padding: 8px 20px;
  height: 32px;
  border-radius: 4px;
`;

const VerticalDivider = styled.span`
  height: 2rem;
  width: 0px;
  border-right: ${(props) => `1px solid ${props.theme.palette.divider}`};
  margin-left: 1.5rem;
  margin-right: 1.5rem;
`;
